import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProfileRefreshService } from '../../../services/http-services/profile-refresh.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-profile-refresh-modal',
  templateUrl: './profile-refresh-modal.component.html',
  styleUrls: ['./profile-refresh-modal.component.scss'],
})
export class ProfileRefreshModalComponent {
  mode: 'due' | 'resume' = 'due';
  lastCompletedStep = 0;
  totalSteps = 8;
  isLoading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private profileRefresh: ProfileRefreshService,
    private router: Router,
    private toastService: ToastService
  ) {}

  updateNow(): void {
    this.isLoading = true;
    const request =
      this.mode === 'resume'
        ? this.profileRefresh.loadStatus()
        : this.profileRefresh.startRefresh();

    request.subscribe({
      next: () => {
        this.isLoading = false;
        this.bsModalRef.hide();
        const url =
          this.profileRefresh.snapshot?.resumeUrl || '/app/completion/step1';
        this.router.navigateByUrl(url);
      },
      error: (err: any) => {
        this.isLoading = false;
        this.toastService.presentErrorToast(err);
      },
    });
  }

  skipForNow(): void {
    this.isLoading = true;
    this.profileRefresh.skipRefresh().subscribe({
      next: () => {
        this.isLoading = false;
        this.bsModalRef.hide();
      },
      error: (err: any) => {
        this.isLoading = false;
        this.toastService.presentErrorToast(err);
      },
    });
  }

  remindLater(): void {
    this.bsModalRef.hide();
  }
}
